export interface Testimonial {
  name: string
  role?: string
  country: string
  /** ISO 3166-1 alpha-2 code, used for the flag image */
  countryCode: string
  text: string
}

/**
 * Fictional sample testimonials for layout purposes only — not verified customer reviews.
 * Replace them with authentic feedback before publishing.
 */
export const testimonials: Testimonial[] = [
  {
    name: 'Michael Anderson',
    country: 'United States',
    countryCode: 'us',
    text: 'Having six machinery specializations organized in one system makes lesson preparation much easier. The technical diagrams and equipment illustrations are exactly the kind of resources I want for my training sessions.',
  },
  {
    name: 'James Mitchell',
    country: 'United Kingdom',
    countryCode: 'gb',
    text: 'The level of visual detail is impressive. Being able to explain excavators, cranes, and other heavy equipment through clear diagrams would make technical training much more engaging and easier to follow.',
  },
  {
    name: 'Daniel Cooper',
    country: 'Canada',
    countryCode: 'ca',
    text: "What I like most is that the system goes beyond machinery illustrations. The workplace scenarios, component identification exercises, and teaching resources make it a valuable addition to an instructor's training library.",
  },
]
